// test1167
(1167 && 0);
